export const Movies = [
  {
    name: "Shanty town",
    desc: "Lorem ipsum dolor sit, amet consectetur adipisicing  elit. Consequatur repellat quo officia ducimus molestias harum est dicta ipsam voluptate iste",
    titleImage:
      "https://www.nairaland.com/attachments/15881300_screenshot20220805135006_jpegf850ffedb41f5058c8f858ad063438a7",
    image:
      "https://businessday.ng/wp-content/uploads/2023/01/Shanty-Town-1.png",
    category: "Action",
    language: "English",
    year: "2023",
    time: "4hrs:20mins",
    video: "https://www.youtube.com/watch?v=oWfF6t9yATM",
    rate: 4.2,
    reviews: 25,
    id: 1,
  },
  {
    name: "The gray man",
    desc: "Lorem ipsum dolor sit, amet consectetur adipisicing  elit. Consequatur repellat quo officia ducimus molestias harum est dicta ipsam voluptate iste",
    titleImage:
      "https://upload.wikimedia.org/wikipedia/en/d/d2/I%27ll_Take_My_Chances_poster.jpg",
    image:
      "https://occ-0-2794-34.1.nflxso.net/dnm/api/v6/6AYY37jfdO6hpXcMjf9Yu5cnmO0/AAAABdy-faTwQD7YK6tirPkhmsovv6blu05YcjEwFCYGa_ToIxtusZGR-edOY-bHfyYNyVo5w46tWCW3IV5Cgx4G196M-V6d-b5FMRNZ.jpg?r=d7f",
    category: "Action / Crime",
    language: "English",
    year: "2023",
    time: "4hrs:30mins",
    video: "https://www.youtube.com/watch?v=oWfF6t9yATM",
    rate: 3.0,
    reviews: 25,
    id: 2,
  },

  {
    name: "Anikulapo",
    desc: "Lorem ipsum dolor sit, amet consectetur adipisicing  elit. Consequatur repellat quo officia ducimus molestias harum est dicta ipsam voluptate iste",
    titleImage:
      "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcR9sfcNSAKtwcJBws43LLNrZ7QN4WzcU0I6AA&usqp=CAU",

    image: "https://i.ytimg.com/vi/vFoLxM9MifI/maxresdefault.jpg",

    category: "Fiction",
    language: "Yoruba",
    year: "2023",
    time: "3hrs:25mins",
    video:
      "https://encrypted-vtbn0.gstatic.com/video?q=tbn:ANd9GcToShdSPCH_CP9wKLq9DoIkwZqi7aCQFrLMTQ",
    rate: 4.5,
    reviews: 35,
    id: 3,
  },

  {
    name: "Brotherhood",
    desc: "Lorem ipsum dolor sit, amet consectetur adipisicing  elit. Consequatur repellat quo officia ducimus molestias harum est dicta ipsam voluptate iste",
    titleImage:
      "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcS1s1ooB2hYytfanoX-Ms5T0DQi0k4_jSEjEPDYMoWy1sLrFHWkLjvSDcGiTnOgM0Y7Fcg&usqp=CAU",
    image:
      "https://whatkeptmeup.com/wp-content/uploads/2022/09/wp-1664185179142..jpg",
    category: "Thriller",
    language: "Hausa",
    year: "2023",
    time: "4hrs:15mins",
    video: "https://www.youtube.com/watch?v=oWfF6t9yATM",
    rate: 3.8,
    reviews: 25,
    id: 4,
  },

  {
    name: "King of boys",
    desc: "Lorem ipsum dolor sit, amet consectetur adipisicing  elit. Consequatur repellat quo officia ducimus molestias harum est dicta ipsam voluptate iste",
    titleImage:
      "https://i0.wp.com/www.gbextra.com.ng/wp-content/uploads/2022/12/5VrNpgvRa9O.jpg?fit=720%2C1008&ssl=1&w=640",

    image: "https://flxt.tmsimg.com/assets/p20487596_i_h8_aa.jpg",
    category: "Fiction",
    language: "Igbo",
    year: "2018",
    time: "4hrs:20mins",
    video: "https://www.youtube.com/watch?v=oWfF6t9yATM",
    rate: 2.3,
    reviews: 35,
    id: 5,
  },

  {
    name: "Anikulapo",
    desc: "Lorem ipsum dolor sit, amet consectetur adipisicing  elit. Consequatur repellat quo officia ducimus molestias harum est dicta ipsam voluptate iste",
    titleImage:
      "https://www.nollywoodreinvented.com/wp-content/uploads/2022/05/The-therapist-819x1024.jpg",
    image: "https://i.ytimg.com/vi/vFoLxM9MifI/maxresdefault.jpg",
    category: "Fiction",
    language: "English",
    year: "2023",
    time: "3hrs:20mins",
    video: "https://www.youtube.com/watch?v=oWfF6t9yATM",
    rate: 1.5,
    reviews: 35,
    id: 6,
  },

  {
    name: "Shanty town",
    desc: "Lorem ipsum dolor sit, amet consectetur adipisicing  elit. Consequatur repellat quo officia ducimus molestias harum est dicta ipsam voluptate iste",
    titleImage:
      "https://i0.wp.com/www.seriezloaded.com.ng/wp-content/uploads/2021/07/wp-1625122426210.jpg?fit=720%2C1080&ssl=1",
    image:
      "https://businessday.ng/wp-content/uploads/2023/01/Shanty-Town-1.png",
    category: "African Magic",
    language: "Action",
    year: "2023",
    time: "4hrs:20mins",
    video: "https://www.youtube.com/watch?v=oWfF6t9yATM",
    rate: 4.2,
    reviews: 25,
    id: 7,
  },

  {
    name: "King of boys",
    desc: "Lorem ipsum dolor sit, amet consectetur adipisicing  elit. Consequatur repellat quo officia ducimus molestias harum est dicta ipsam voluptate iste",
    titleImage:
      "https://i0.wp.com/mediarants.com/wp-content/uploads/2021/12/7EEB1B25-5242-466C-A0FB-E760A072EC81.jpeg?w=740&ssl=1",
    image: "https://flxt.tmsimg.com/assets/p20487596_i_h8_aa.jpg",
    category: "Fiction",
    language: "Yoruba",
    year: "2018",
    time: "4hrs:20mins",
    video: "https://www.youtube.com/watch?v=oWfF6t9yATM",
    rate: 2.3,
    reviews: 35,
    id: 8,
  },

  {
    name: "King of boys",
    desc: "Lorem ipsum dolor sit, amet consectetur adipisicing  elit. Consequatur repellat quo officia ducimus molestias harum est dicta ipsam voluptate iste",
    titleImage:
      "https://i0.wp.com/mediarants.com/wp-content/uploads/2021/12/7EEB1B25-5242-466C-A0FB-E760A072EC81.jpeg?w=740&ssl=1",
    image: "https://flxt.tmsimg.com/assets/p20487596_i_h8_aa.jpg",
    category: "Fiction",
    language: "Enblish",
    year: "2018",
    time: "4hrs:20mins",
    video: "https://www.youtube.com/watch?v=oWfF6t9yATM",
    rate: 2.3,
    reviews: 35,
    id: 9,
  },

  {
    name: "King of boys",
    desc: "Lorem ipsum dolor sit, amet consectetur adipisicing  elit. Consequatur repellat quo officia ducimus molestias harum est dicta ipsam voluptate iste",
    titleImage:
      "https://i0.wp.com/mediarants.com/wp-content/uploads/2021/12/7EEB1B25-5242-466C-A0FB-E760A072EC81.jpeg?w=740&ssl=1",
    image: "https://flxt.tmsimg.com/assets/p20487596_i_h8_aa.jpg",
    category: "Fiction",
    language: "English",
    year: "2018",
    time: "4hrs:20mins",
    video: "https://www.youtube.com/watch?v=oWfF6t9yATM",
    rate: 2.3,
    reviews: 35,
    id: 10,
  },

  {
    name: "King of boys",
    desc: "Lorem ipsum dolor sit, amet consectetur adipisicing  elit. Consequatur repellat quo officia ducimus molestias harum est dicta ipsam voluptate iste",
    titleImage:
      "https://i0.wp.com/mediarants.com/wp-content/uploads/2021/12/7EEB1B25-5242-466C-A0FB-E760A072EC81.jpeg?w=740&ssl=1",
    image: "https://flxt.tmsimg.com/assets/p20487596_i_h8_aa.jpg",
    category: "Fiction",
    language: "French",
    year: "2018",
    time: "4hrs:20mins",
    video: "https://www.youtube.com/watch?v=oWfF6t9yATM",
    rate: 2.3,
    reviews: 35,
    id: 11,
  },

  {
    name: "King of boys",
    desc: "Lorem ipsum dolor sit, amet consectetur adipisicing  elit. Consequatur repellat quo officia ducimus molestias harum est dicta ipsam voluptate iste",
    titleImage:
      "https://i0.wp.com/mediarants.com/wp-content/uploads/2021/12/7EEB1B25-5242-466C-A0FB-E760A072EC81.jpeg?w=740&ssl=1",
    image: "https://flxt.tmsimg.com/assets/p20487596_i_h8_aa.jpg",
    category: "Fiction",
    language: "English",
    year: "2018",
    time: "4hrs:20mins",
    video: "https://www.youtube.com/watch?v=oWfF6t9yATM",
    rate: 2.3,
    reviews: 35,
    id: 12,
  },

  {
    name: "King of boys",
    desc: "Lorem ipsum dolor sit, amet consectetur adipisicing  elit. Consequatur repellat quo officia ducimus molestias harum est dicta ipsam voluptate iste",
    titleImage:
      "https://i0.wp.com/mediarants.com/wp-content/uploads/2021/12/7EEB1B25-5242-466C-A0FB-E760A072EC81.jpeg?w=740&ssl=1",
    image: "https://flxt.tmsimg.com/assets/p20487596_i_h8_aa.jpg",
    category: "Fiction",
    language: "Korean",
    year: "2018",
    time: "4hrs:20mins",
    video: "https://www.youtube.com/watch?v=oWfF6t9yATM",
    rate: 2.3,
    reviews: 35,
    id: 13,
  },
];

export const UserData = [
  {
    fullname: "Nancy Isime",
    image:
      "https://naijabionet.com/wp-content/uploads/2023/01/CBD8462A-E6EC-4CF1-B5A8-DEBAB47D00E8.jpeg",
  },

  {
    fullname: "Iniedo Lucy",
    image:
      "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTVHFdvXB_NjnTZIJDhyCEV59zRloG8pbjL45GU1f3rf63EUvJkFDTsOu5KlhUKxPrbTFQ&usqp=CAU",
  },

  {
    fullname: "Peter Okoye",
    image:
      "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTVgx4i0JLDxi1kSooInj3v21_91zQ-FuJxJg&usqp=CAU",
  },

  {
    fullname: "Chidi Mokeme",
    image:
      "https://imagedelivery.net/_gBuZPdvC0s7HRi4RhiSIA/08688f2c-f2c7-4ba7-28ce-eadfdf4c4700/public",
  },

  {
    fullname: "RMD",
    image: "https://tribuneonlineng.com/wp-content/uploads/2023/01/RMD.jpg",
  },

  {
    fullname: "Mercy Eke",
    image:
      "https://i0.wp.com/exquisitemag.com/wp-content/uploads/2023/01/206BD766-CB61-45AE-8640-A693F2A8A5E4.jpeg",
  },

  {
    fullname: "Zuby Micheal",
    image:
      "https://dnbstories.com/wp-content/uploads/2021/06/zubby-michael-full-biography.jpg",
  },

  {
    fullname: "Alex Ekubo",
    image:
      "https://file.naijauto.com/crop/415x310/2020/08/31/u0GUC7wC/alex-ekubo-319b.jpg",
  },

  {
    fullname: "Boss Lady",
    image:
      "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSVC7HltAkB_yT3jbj03MPM24L0Jd-28XsKTNzE_AqjySW94VGFfIhHb4qOkV6RxG8_Tjs&usqp=CAU",
  },
];
